export class AppConstants {
  static token: string = "";
  static base_url_api: string = `${process.env.REACT_APP_MY_URL}/api/v1/`;

  static base_url_download: string = `${process.env.REACT_APP_MY_URL}`;
  static base_url_img: string = `${process.env.REACT_APP_MY_URL}/media`;


  

  static domain: string = `${process.env.REACT_APP_BASE_URL}`;

  static redirect_url: string = `${process.env.REACT_APP_SSO_URL}/authentication/init`;

  static redirect_crm_url: string = `${process.env.REACT_APP_CRM_URL}/`;
  static base_core_url_img: string = `${process.env.REACT_APP_CORE_URL}/media`;
  static base_core_url: string = `${process.env.REACT_APP_CORE_URL}`;



}
